module.exports = __webpack_public_path__ + "zvetseni-prsou_3_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_3_after.jpg
// module id = 1331
// module chunks = 0